exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__modalHeader___1HXAZ{font-family:PlayfairDisplay-Regular;font-size:32px;font-weight:300;margin:0}.style__modalHeader___1HXAZ sup{position:relative;top:8px}.style__headerDetails___YyJXH{font-family:PlayfairDisplay-Regular;font-style:italic;font-size:18px;margin:12px 0}.style__price___3WgaF{color:#c1887f;font-size:18px;text-align:left}.style__hr___2Cc3Z{margin:20px 0}.style__add___24w8-{margin-top:40px}.style__add___24w8- *{margin:0 auto;display:block}", ""]);

// exports
exports.locals = {
	"modalHeader": "style__modalHeader___1HXAZ",
	"headerDetails": "style__headerDetails___YyJXH",
	"price": "style__price___3WgaF",
	"hr": "style__hr___2Cc3Z",
	"add": "style__add___24w8-"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/jewelry-modal/style.css
// module id = 683
// module chunks = 0